import { DimensionApplicationPaymentReportData } from './dimension-application-payment-report-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class VariationApplicationPaymentReportData {
  ScaffoldNumber: string;
  ScaffoldDescription: string;
  QuoteNo: string;
  ItemNo: string;
  OffHiredDate: string;
  StaffName: string;
  Comments: string;
  ContractPrice: string;
  ExtraHireRate: string;
  SiteInstructionReference: string;
  SiteInstructionBy: string;
  Dimensions: DimensionApplicationPaymentReportData[];
}


